(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["box-builder"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.customElements.get('box-builder')) return;

    function fmt(cents) {
      return '€' + (cents / 100).toFixed(2).replace('.', ',');
    }

    customElements.define('box-builder', class extends HTMLElement {
      connectedCallback() {
        try {
          this.cfg = JSON.parse(this.querySelector('[data-config]').textContent);
        } catch (e) { return; }

        this.type = 'mixed';
        this.count = 0;

        this.addBtn = this.querySelector('[data-add]');
        this.totalEl = this.querySelector('[data-total]');
        this.errorEl = this.querySelector('[data-error]');

        this.querySelectorAll('[data-type]').forEach((b) => {
          b.addEventListener('click', () => this.setType(b.dataset.type));
        });
        this.querySelectorAll('[data-count]').forEach((b) => {
          b.addEventListener('click', () => this.setCount(parseInt(b.dataset.count, 10), b));
        });

        var active = this.querySelector('[data-count].is-active') || this.querySelector('[data-count]');
        if (active) this.setCount(parseInt(active.dataset.count, 10), active);

        this.addBtn.addEventListener('click', () => this.add());
      }

      setType(type) {
        this.type = type;
        this.querySelectorAll('[data-type]').forEach((b) => {
          var on = b.dataset.type === type;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }

      setCount(count, btn) {
        this.count = count;
        this.querySelectorAll('[data-count]').forEach((b) => {
          var on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        this.render();
      }

      // Returns { full, half } box counts for a guest total.
      boxesFor(count) {
        var fulls = Math.floor(count / this.cfg.fullServes);
        var rem = count - fulls * this.cfg.fullServes;
        var halves = 0;
        if (rem === this.cfg.halfServes) halves = 1;
        else if (rem > 0) fulls += 1; // safety net for non-standard counts
        return { full: fulls, half: halves };
      }

      render() {
        if (this.totalEl) this.totalEl.textContent = fmt(this.count * this.cfg.perPerson);
      }

      setError(msg) {
        if (!this.errorEl) return;
        this.errorEl.textContent = msg || '';
        this.errorEl.hidden = !msg;
      }

      add() {
        if (this.addBtn.getAttribute('aria-disabled') === 'true') return;
        this.setError('');

        var v = this.cfg.variants[this.type] || {};
        var boxes = this.boxesFor(this.count);
        var items = [];
        if (boxes.full > 0 && v.full) items.push({ id: v.full, quantity: boxes.full });
        if (boxes.half > 0 && v.half) items.push({ id: v.half, quantity: boxes.half });

        if (!items.length) { this.setError('Please pick a box and guest count.'); return; }

        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        this.addBtn.setAttribute('aria-disabled', 'true');

        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then((r) => r.json().then((data) => ({ ok: r.ok, data: data })))
          .then((res) => {
            if (!res.ok) throw new Error((res.data && res.data.description) || 'Could not add to cart.');
            if (this.cfg.afterAdd === 'stay') {
              this.addBtn.removeAttribute('aria-disabled');
              this.setError('');
            } else {
              window.location.href = this.cfg.cartUrl || (root + 'cart');
            }
          })
          .catch((err) => {
            this.addBtn.removeAttribute('aria-disabled');
            this.setError(err.message || 'Could not add to cart.');
          });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["sticker"] && !Shopify.designMode) return;
  try {
    // Scroll-driven rotation for sticker blocks. Loaded once per block type.
  (function () {
    if (window.__stickerScrollInit) return;
    window.__stickerScrollInit = true;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var ticking = false;

    function update() {
      ticking = false;
      var els = document.querySelectorAll('.sticker-block[data-scroll-rotate]');
      if (!els.length) return;
      var y = window.scrollY || window.pageYOffset || 0;
      for (var i = 0; i < els.length; i++) {
        var factor = parseFloat(els[i].getAttribute('data-spin-factor')) || 0;
        els[i].style.setProperty('--stk-spin', (y * factor).toFixed(2) + 'deg');
      }
    }

    function reset() {
      var els = document.querySelectorAll('.sticker-block[data-scroll-rotate]');
      for (var i = 0; i < els.length; i++) {
        els[i].style.setProperty('--stk-spin', '0deg');
      }
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    function enable() {
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    }

    function disable() {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      reset();
    }

    if (!reduce.matches) enable();

    // Honour live changes to the OS "reduce motion" preference.
    var onChange = function (e) { e.matches ? disable() : enable(); };
    if (reduce.addEventListener) reduce.addEventListener('change', onChange);
    else if (reduce.addListener) reduce.addListener(onChange);

    // In the theme editor, blocks are added/re-rendered without a page reload.
    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', update);
      document.addEventListener('shopify:block:select', update);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
